import { commonUtils } from '../common';

export default {
  showTip: (str: string) => {
    uni.showModal({
      title: str,
      showCancel: false,
      success: () => {
        commonUtils.page.back();
      },
    });
  },
};
